import React from 'react'

import { Button } from '@/components'
import OralExamAudioPlayButton, {
  deriveMimeTypeFromUrl,
} from './OralExamAudioPlayButton'

import './OralExam.scss'

const OralExamActivityFeedback = ({
  audioUrl,
  currentQuestion,
  feedback,
  isCorrect,
  learningObjectives,
  onEnded,
  onNext,
  onPause,
  onPlay,
  question,
  totalQuestions,
  transcribedText,
}) => {
  const {
    content: questionContent,
    question: questionStem,
    textBeforeInput: questionText,
  } = question || {}
  return (
    <div className="oral-exam__activity-feedback">
      <div className="oral-exam__progress">
        <p>
          Question {currentQuestion} of {totalQuestions}
        </p>
      </div>
      <div className="oral-exam__wrapper">
        <p className="oral-exam__question-text">
          {questionStem || questionContent || questionText}
        </p>

        {audioUrl && (
          <div className="oral-exam__audio-player">
            <OralExamAudioPlayButton
              audioType={deriveMimeTypeFromUrl(audioUrl, 'audio/wav')}
              audioUrl={audioUrl}
              isRecording={false}
              onEnded={onEnded}
              onPause={onPause}
              onPlay={onPlay}
            />
          </div>
        )}

        <div
          className={`oral-exam__transcription-result${
            isCorrect !== null
              ? isCorrect
                ? ' oral-exam__transcription-result--is-correct'
                : ' oral-exam__transcription-result--is-incorrect'
              : ''
          }`}
        >
          <p className="oral-exam__transcription-result-title">Your answer:</p>
          <p className="oral-exam__transcribed-text">
            {transcribedText || 'No Answer Submitted'}
          </p>
          {isCorrect !== null && (
            <div className="oral-exam__answer-status">
              {isCorrect ? (
                <span className="oral-exam__status-text--correct">
                  &#10003; Correct
                </span>
              ) : (
                <span className="oral-exam__status-text--incorrect">
                  &#10005; Incorrect
                </span>
              )}
            </div>
          )}
        </div>

        {feedback && feedback.length > 0 && (
          <div className="oral-exam__feedback">
            <div className="oral-exam__feedback-section">
              <div className="oral-exam__feedback-section-title">Feedback:</div>
              {feedback.map((feedbackItem, index) => (
                <p
                  className="oral-exam__feedback-section-text"
                  dangerouslySetInnerHTML={{ __html: feedbackItem }}
                  key={index}
                />
              ))}
            </div>
          </div>
        )}

        {learningObjectives && learningObjectives.length > 0 && (
          <div className="oral-exam__learning-objectives">
            <div className="oral-exam__learning-objectives-title">
              Learning Objectives:
            </div>
            {learningObjectives.map((objective, index) => (
              <p className="oral-exam__learning-objectives-text" key={index}>
                {objective}
              </p>
            ))}
          </div>
        )}
      </div>
      <div className="oral-exam__submit">
        <Button isInfo isRounded onClick={onNext}>
          Next
        </Button>
      </div>
    </div>
  )
}

export default OralExamActivityFeedback
